import React from 'react';
export function Divider() {
  return <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent m-0 w-full" data-id="element-146" />;
}